<template>
  <div
    class="hosted-toggle"
    :class="{
      'hosted-toggle--small': small,
    }"
    @click="toggle"
  >
    <div class="hosted-toggle__options">
      <span class="hosted-toggle__option"
        ><i class="hosted-toggle__option-icon iconoir-cloud-upload"></i>Cloud
        <strong v-if="!small" class="hosted-toggle__option-highlight"
          >(we host)</strong
        >
      </span>
      <span class="hosted-toggle__option"
        ><i class="hosted-toggle__option-icon iconoir-db"></i>Self-host
        <strong v-if="!small" class="hosted-toggle__option-highlight"
          >(you host)</strong
        ></span
      >
    </div>

    <button
      class="hosted-toggle__switch"
      :class="{
        'hosted-toggle__switch--left': value == 'hosted',
        'hosted-toggle__switch--right': value == 'self-hosted',
      }"
    ></button>
  </div>
</template>

<script>
export default {
  name: 'HostedSelfHostedToggle',
  props: {
    value: {
      type: String,
      required: true,
      default: 'hosted',
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toggle() {
      this.$emit('input', this.value === 'hosted' ? 'self-hosted' : 'hosted')
    },
  },
}
</script>
